var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M17.5,10.62601V0H1.87601C.84324-.00331,.00333,.83122,0,1.86399c-.00001,.00401-.00001,.00801,0,.01202V38.12599c-.00221,1.03277,.83322,1.87179,1.86598,1.874,.00334,0,.00668,0,.01001,0H28.126c1.03277,.00221,1.87179-.83322,1.874-1.86599,0-.00267,0-.00534,0-.00801V12.5h-10.624c-1.03439-.0022-1.8727-.83961-1.876-1.874Zm12.49999-1.102v.476h-10V0h.476c.49622-.00047,.97236,.19589,1.324,.546l7.654,7.654c.35048,.35139,.54691,.8277,.546,1.324Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.1fe1649fa78d1073d551d98f95074125.svg";
export { ForwardRef as ReactComponent };